<template>
  <section class="advance-article">
    <h2 ref="title">{{ title }}</h2>
    <h3 ref="subtitle">{{ subtitle }}</h3>
    <Article v-if="copy" :text-content="copyData" />
    <NavLink
      v-track="buttonProps.tracking"
      v-bind="buttonProps"
      :link="buttonProps.link ? buttonProps.link[0].link : buttonProps.to"
      :routing-component="AppButton"
    ></NavLink>
  </section>
</template>

<script>
import Article from "./Article"
import stubDirectives from "../mixins/stubDirectives"
import buttonProps from "../helpers/buttonProps"
import NavLink from "./NavLink.vue"
import AppButton from "./AppButton"
import markRaw from "../helpers/markRaw"

export default {
  components: {
    Article,
    NavLink
  },
  mixins: [stubDirectives],
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    copy: {
      type: Array,
      default: null
    },
    button: {
      type: Array,
      default: null
    },
    userSignedIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AppButton: markRaw(AppButton)
    }
  },
  computed: {
    buttonProps() {
      return buttonProps(this.button, this.userSignedIn)
    },
    copyData() {
      return this.copy?.[0]?.textContent ? this.copy[0].textContent : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.advance-article {
  max-width: 800px;
  margin: auto;
  padding: $space-15 $space-6;
}
</style>
